import { useCallback } from "react";
import { useMessageToState } from "../../../../hooks/useMessageToState";
import { useLogicalSelectedPage } from "../../../../hooks/useSelection";

export function useBackground() {
	const page = useLogicalSelectedPage();

	return useMessageToState({
		name: "useBackground",
		getState: useCallback(() => page?.background, [page]),
		filterMessage: (message) => {
			if (message instanceof eXpress.core.BackgroundsMessage) return true;
			if (message instanceof eXpress.core.CurrentSpreadChangedMessage) return true;
			if (message instanceof eXpress.core.DefinitionSpreadCollectionChangedMessage)
				return true;
			if (message instanceof eXpress.core.CurrentZoneChangedMessage) return true;

			return false;
		},
	});
}
